import { rem } from 'polished';
import React, { memo } from 'react';
import useTranslations from '@hooks/useTranslations';
import styled from 'styled-components';

export const Losange: React.FC<{ label?: string }> = memo(({ label }) => {
    const { t } = useTranslations();

    if (!label) return null;
    return (
        <LosangeStyled>
            <div className="arrow">{label || t('trim.lozenge')}</div>
        </LosangeStyled>
    );
});
Losange.displayName = 'Losange';

const LosangeStyled = styled.div`
    position: absolute;
    right: -${rem(10)};
    top: ${rem(12)};

    & > .arrow {
        position: relative;
        padding: 0 ${rem('12px')};
        line-height: ${rem('28px')};
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        background: ${({ theme }) => theme.colors.lozenge};
        color: ${({ theme }) => theme.colors.white};

        &::after {
            position: absolute;
            right: 0;
            bottom: ${rem('-10px')};
            content: '';
            width: 0;
            height: 0;
            border-top: ${rem('10px')} solid ${({ theme }) => theme.colors.lozengeArrow};
            border-right: ${rem('10px')} solid transparent;
        }
    }
`;
